import { ActivityIndicator, FlatList } from "react-native";

import TicketListItem from "../TicketListtem";
import TicketListHeader from "../TicketListHeader";

import { TicketListProps } from "./types";

const TicketList: React.FC<TicketListProps> = ({
  loading,
  loadingMore,
  eventOccurrenceId,
  ...props
}) => (
  <>
    {loading && <ActivityIndicator />}
    <FlatList
      {...props}
      keyExtractor={({ id }) => id.toString()}
      renderItem={({ item }) => (
        <TicketListItem {...item} {...{ eventOccurrenceId }} />
      )}
      ListHeaderComponent={TicketListHeader}
      stickyHeaderIndices={[0]}
    />
    {loadingMore && <ActivityIndicator />}
  </>
);

export default TicketList;
